/**
 * @description
 * Objeto wsdefs
 */

 import { Setvalues } from "./setvalues.model";
 import { Typeruns } from "./typeruns.model";
 import { Xmldefs } from "./xmldefs.model";
 import { Typefinders } from "./typefinders.model";

export class Wsdefs {
    public id:number = null;
    public code:string = "";
    public desc:string;
    public url:string;
    public xmlin:string;
    public online:number = null;
    public setvalue: Setvalues = new Setvalues();
    public typerun: Typeruns = new Typeruns();
    public xmldef: Xmldefs = new Xmldefs();
    public typefinder: Typefinders = new Typefinders();
    public filterenabled:number = null;
    public paginateenabled:number = null;
    public enable:number=null;
    public numorder:number = null;
    public quickview: number = null;
    public cat:string;
    public esp:string;
  
    constructor() {}
  
}